import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    return (
        <>
            <header className="fixed top-0 left-0 w-full z-50 border-b border-white/5 bg-background-dark/90 backdrop-blur-xl">
                <div className="max-w-[1400px] mx-auto px-8 h-24 flex items-center justify-between">
                    <Link to="/" className="flex items-center gap-4 hover:opacity-80 transition-opacity relative z-50">
                        <div className="size-10 bg-primary flex items-center justify-center">
                            <span className="text-black font-black text-xl italic">TH</span>
                        </div>
                        <h2 className="text-2xl font-black sports-font tracking-tighter text-white">Taven<span className="text-primary">.</span>Harris</h2>
                    </Link>

                    <nav className="hidden md:flex items-center gap-12">
                        <Link className="text-xs font-bold uppercase tracking-[0.2em] hover:text-primary transition-colors" to="/portfolio">Portfolio</Link>
                        <Link className="text-xs font-bold uppercase tracking-[0.2em] hover:text-primary transition-colors" to="/stack">Stack</Link>
                        <Link className="text-xs font-bold uppercase tracking-[0.2em] hover:text-primary transition-colors" to="/experience">Experience</Link>
                    </nav>

                    <a href="mailto:career@tavenharris.com" className="hidden md:inline-flex group relative px-8 py-3 bg-white text-black font-black uppercase text-xs tracking-widest overflow-hidden transition-all hover:bg-primary items-center">
                        <span className="relative z-10">Get in Touch</span>
                    </a>

                    {/* Mobile Menu Button */}
                    <button
                        className="md:hidden text-white relative z-50 p-2 hover:text-primary transition-colors"
                        onClick={() => setIsMenuOpen(!isMenuOpen)}
                        aria-label="Toggle menu"
                    >
                        {isMenuOpen ? (
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        ) : (
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
                            </svg>
                        )}
                    </button>
                </div>
            </header>

            {/* Mobile Menu Overlay */}
            <div className={`fixed inset-0 bg-black z-40 flex flex-col items-center justify-start pt-32 gap-10 transition-all duration-300 md:hidden ${isMenuOpen ? 'opacity-100 visible' : 'opacity-0 invisible pointer-events-none'}`}>
                <Link onClick={() => setIsMenuOpen(false)} className="text-3xl font-black uppercase tracking-widest hover:text-primary transition-colors" to="/portfolio">Portfolio</Link>
                <Link onClick={() => setIsMenuOpen(false)} className="text-3xl font-black uppercase tracking-widest hover:text-primary transition-colors" to="/stack">Stack</Link>
                <Link onClick={() => setIsMenuOpen(false)} className="text-3xl font-black uppercase tracking-widest hover:text-primary transition-colors" to="/experience">Experience</Link>
                <a href="mailto:career@tavenharris.com" onClick={() => setIsMenuOpen(false)} className="text-xl font-bold uppercase tracking-widest text-primary hover:text-white transition-colors mt-4">
                    Get in Touch
                </a>
            </div>
        </>
    );
};

export default Header;
